import { i18n } from 'i18n';

export interface CustomReportTemplatesPageParams extends Record<string, string | undefined> {
  projectId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';

// Project-level home for authoring report templates once for the whole mine (colours, logo, fields,
// bound data). Distinct from the stope-scoped custom-reports page, which is about filling/generating.
export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/overview/custom-reports`;
export const TITLE = i18n._('Custom Reports');
